import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import Aboutcard from "./AboutCard";
import myImage from "../../Assets/myimg.JPEG";
import CodingWebsiteStack from './CodingWebsiteStack';
import Certificates from "./Certificates";
import Education from "./Education";
import Experience from "./Experience";
import Achievements from "./Achievements";

function About() {
  return (
    <Container fluid className="about-section">
      <Container>
        <Row style={{ justifyContent: "left", padding: "10px" }}>
          <Col
            md={7}
            style={{
              justifyContent: "left",
              paddingTop: "30px",
              paddingBottom: "50px",
            }}
          >
            <Aboutcard />
          </Col>
          <Col
            md={5}
            style={{ paddingTop: "30px", paddingBottom: "50px" }}
            className="about-img"
          >
            <img src={myImage} alt="about" className="img-fluid" />
          </Col>
        </Row>
            
        <div style={{marginLeft:20, paddingBottom: "50px"}}><CodingWebsiteStack  /></div>
        <div style={{marginLeft:20, paddingBottom: "50px"}}><Education  /></div>
        <div style={{marginLeft:20, paddingBottom: "50px"}}><Experience  /></div>
        <div style={{marginLeft:20, paddingBottom: "50px"}}><Achievements  /></div>
        {/* <h1 class="d-flex justify-content-start"  style={{marginLeft:20}}><strong >Certificates </strong></h1> */}
        <div style={{marginLeft:20, paddingBottom: "50px"}}><Certificates  /></div>

      </Container>
    </Container>
  );
}

export default About;
